var nav_breakpoint = '1280px';
var previous_padding_top = '';
var header = document.getElementsByTagName('header')[0];
var mobile_menu = document.getElementById('mobile-menu');
var mobile_toggle = document.getElementById('mobile-toggle');
var context = document.getElementById('mobile-context');
var context_title = document.getElementById('mobile-context-title');

var focusTrap = require('focus-trap');

var parent_trap = focusTrap.createFocusTrap(['header', '#mobile-menu']);
var child_trap;
document.addEventListener('click', function (event) {
  // Only run on our select menu
  if (!event.target.matches('.hamburger-menu')) return;
  header = document.getElementsByTagName('header')[0];
  mobile_menu = document.getElementById('mobile-menu');
  mobile_toggle = document.getElementById('mobile-toggle');

  if (!document.body.classList.contains('mobile-menu-active') && mobile_menu) {
    open_menu();
  } else if (mobile_menu) {
    close_menu();
  }
});
document.addEventListener('click', function (event) {
  //if the mobile nav is visible
  if (window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {
    var target = event.target.matches('.menu-item-has-children') ? event.target : false; // Only run on our select menu

    if (target) {
      event.preventDefault();
      mobile_navigation_controller(target);
    }
  }
});
document.addEventListener('click', function (event) {
  //if the mobile nav is visible
  if (window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {
    // Only run on our select menu
    if (!event.target.matches('.sub-menu-back')) return; //first attempt to get a grandchild menu

    var active_menu = document.getElementsByClassName('sliding-submenu-child'); //if no grandchildren are active

    if (active_menu.length == 0) {
      //target the parent
      active_menu = document.getElementsByClassName('sliding-submenu');
    }

    if (active_menu[0]) {
      var sub_menu = active_menu[0].getElementsByClassName('keyboard-nav-toggle');

      if (sub_menu[0]) {
        mobile_navigation_controller(sub_menu[0]);
      }
    }
  }
});

var debounce = require('debounce');

window.addEventListener('resize', debounce(function (e) {
  if (window.matchMedia('(min-width: ' + nav_breakpoint + ')').matches && document.body.classList.contains('mobile-menu-active')) {
    close_menu();
  }
}, 200));

function open_menu() {
  mobile_toggle.classList.add('animate');
  document.body.classList.add('mobile-menu-active');
  parent_trap.activate();
  mobile_menu.classList.remove('invisible');
  previous_padding_top = document.body.style.paddingTop;
  document.body.style.paddingTop = header.offsetHeight + 'px';
  setTimeout(function () {
    mobile_menu.classList.remove('scroll-lock');
  }, 300);
}

function close_menu() {
  mobile_toggle.classList.remove('animate');
  document.body.classList.remove('mobile-menu-active');
  parent_trap.deactivate();

  if (child_trap) {
    child_trap.deactivate();
  }

  document.body.style.paddingTop = previous_padding_top;
  previous_padding_top = '';
  context.classList.add('pointer-events-none');
  setTimeout(function () {
    mobile_menu.classList.add('invisible');
    mobile_menu.classList.add('scroll-lock');
    var active_link_items = mobile_menu.querySelectorAll('.keyboard-nav-toggle, .sliding-submenu, .sliding-submenu-child');

    if (active_link_items.length) {
      for (var i = 0; i < active_link_items.length; i++) {
        active_link_items[i].classList.remove('keyboard-nav-toggle');
        active_link_items[i].classList.remove('sliding-submenu');
        active_link_items[i].classList.remove('sliding-submenu-child');
      }
    }
  }, 300);
}

function mobile_navigation_controller(li) {
  //add a class indicating it's been toggled
  li.classList.toggle('keyboard-nav-toggle');

  if (li.childNodes[0].innerHTML) {
    context_title.innerHTML = li.childNodes[0].innerHTML;
  }

  if (li.parentNode.parentNode.classList.contains('menu-item-has-children')) {
    li.parentNode.classList.toggle('sliding-submenu-child');
  } else {
    li.parentNode.classList.toggle('sliding-submenu');
  }

  if (li.classList.contains('keyboard-nav-toggle')) {
    child_trap = focusTrap.createFocusTrap(['header', li.childNodes[2]]);
    context.classList.remove('pointer-events-none');
    parent_trap.deactivate();
    child_trap.activate();
  } else {
    if (li.parentNode.parentNode.classList.contains('menu-item-has-children')) {
      context_title.innerHTML = li.parentNode.parentNode.childNodes[0].innerHTML;
      child_trap.deactivate();
      child_trap = focusTrap.createFocusTrap(['header', li.parentNode.parentNode.childNodes[2]]);
      child_trap.activate();
    } else {
      context.classList.add('pointer-events-none');
      context_title.innerHTML = '';
      child_trap.deactivate();
      parent_trap.activate();
    }
  }
}

document.addEventListener('keydown', function (event) {
  if (event.code == "Escape") {
    close_menu();
  }
});